import React from 'react';
import { InputAdornment, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
    startAdornment: {
        paddingLeft: '12px',
    },
}));

const BookingNumberInputAdornment = () => {
    const classes = styles();

    return (
        <InputAdornment position="start">
            <Typography variant="body2" className={classes.startAdornment}>
                BKG-
            </Typography>
        </InputAdornment>
    );
};

export default BookingNumberInputAdornment;
